var
    selector = {
        tags: '.related-products .widget.widget-tags a',
        tagsTop: '.related-products-top-buttons .widget.widget-tags a',
        container: '.related-products.accessories .items'
    },
    url = {
        ajaxRelated: '/index.php?route=product/ajax_product_related'
    },
    self = this,
    _vtbl = null
    ;
initialize();
bindUI();
function initialize() {
    _vtbl = {
        tags: $(selector.tags),
        tagsTop: $(selector.tagsTop),
        container: $(selector.container)
    }
}
function bindUI() {
    _vtbl.tags.each(function (i, node) {
        node = $(node);
        node.on('click', onClickTag);
    });
    _vtbl.tagsTop.each(function (i, node) {
        node = $(node);
        node.on('click', onClickTagTop);
    });
}
if ($('.related-products-top-buttons .widget.widget-tags').length) {
    //$('.related-products-top-buttons .widget.widget-tags').plug(Y.Plugin.ScrollNav);
}
function onClickTagTop(ev) {
    _vtbl.tags.each(function (i, node) {
        node = $(node);
        if ($(this).attr('data-category_id') == node.attr('data-category_id')) {
            node[0].click();
        }
    }, this);
}
function onClickTag(ev) {
    _vtbl.tags.removeClass('active');
    $(this).addClass('active');
    $.ajax(url.ajaxRelated, {
        data: {
            category_id: $(this).attr('data-category_id'),
            product_id: $(this).attr('data-product_id'),
            start: $(this).attr('data-start'),
            limit: $(this).attr('data-limit')
        },
        arguments: {
            count: parseInt($(this).attr('data-count')),
            isAppend: parseInt($(this).attr('data-start')) > 0,
            start: parseInt($(this).attr('data-start')),
            limit: parseInt($(this).attr('data-limit')),
            node: this
        },
        success: function (o, statusText) {
            //node.setAttribute('data-start', args.start + args.limit);
            //if (args.isAppend)
            //    _vtbl.container.append(o.responseText);
            //else
            _vtbl.container.html(o);
            /*
            self._controlButtonAddToCart();
             */
            var owl = _vtbl.container.data('owlCarousel');
            owl.reinit({
                items: 4,
                autoPlay: false,
                navigation: false,
                pagination: true,
                responsive: true,
                itemsDesktopSmall: [1199, 3],
                itemsTablet: [959, 2],
                itemsTabletSmall: [899, 3],
                itemsMobile: [480, 1]
            });
            //require('./sliders');
            //_vtbl.container.removeClass('owl-carousel');
            //_vtbl.container.removeClass('owl-themel');
            //jQuery('.related-posts > .items, .related-products > .items, .new-arrivals > .items, .best-sellers > .items').each( function() {
            //
            //    jQuery(this).owlCarousel({
            //        items: 4,
            //        autoPlay: false,
            //        navigation: false,
            //        pagination: true,
            //        responsive: true,
            //        itemsDesktopSmall: [1199,3],
            //        itemsTablet: [959,2],
            //        itemsTabletSmall: [899,3],
            //        itemsMobile: [480,1]
            //    });
            //
            //});
            /*jQuery(_vtbl.container.getDOMNode()).owlCarousel({
             items: 4,
             autoPlay: false,
             navigation: false,
             pagination: true,
             responsive: true,
             itemsDesktopSmall: [1199,3],
             itemsTablet: [959,2],
             itemsTabletSmall: [899,3],
             itemsMobile: [480,1]
             });*/
        }
    })
}



// WEBPACK FOOTER //
// ./assets/javascript/productacessories.js